// UTM + marketing attribution capture
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
const CLICK_KEYS = ["gclid", "gbraid", "wbraid"];

export function captureAttribution() {
  const params = new URLSearchParams(window.location.search);
  const utm = {};
  let hasUtm = false;
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) {
      utm[k] = v;
      hasUtm = true;
    }
  });

  // Google click identifiers — persisted for the whole session (never fabricated)
  CLICK_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) localStorage.setItem(`ec_${k}`, v);
  });

  // first touch persists across sessions
  if (hasUtm && !localStorage.getItem("ec_first_touch")) {
    localStorage.setItem(
      "ec_first_touch",
      JSON.stringify({ ...utm, landing_page: window.location.pathname, referrer: document.referrer, at: new Date().toISOString() })
    );
  }
  // last touch updates whenever utm present
  if (hasUtm) {
    sessionStorage.setItem("ec_last_touch", JSON.stringify(utm));
  }
  if (!localStorage.getItem("ec_landing_page")) {
    localStorage.setItem("ec_landing_page", window.location.pathname + window.location.search);
  }
}

export function getAttribution() {
  let first = {};
  let last = {};
  try {
    first = JSON.parse(localStorage.getItem("ec_first_touch") || "{}");
  } catch (e) {}
  try {
    last = JSON.parse(sessionStorage.getItem("ec_last_touch") || "{}");
  } catch (e) {}
  const merged = { ...first, ...last };
  return {
    utm_source: merged.utm_source || null,
    utm_medium: merged.utm_medium || null,
    utm_campaign: merged.utm_campaign || null,
    utm_term: merged.utm_term || null,
    utm_content: merged.utm_content || null,
    gclid: localStorage.getItem("ec_gclid") || null,
    gbraid: localStorage.getItem("ec_gbraid") || null,
    wbraid: localStorage.getItem("ec_wbraid") || null,
    landing_page: localStorage.getItem("ec_landing_page") || window.location.pathname,
    referrer: document.referrer || null,
  };
}
